import { Controller } from "@hotwired/stimulus"

// フォーム要素 ( select など ) の change で自動送信する。
// 使い方:
//   = form_with(...) do |f|
//     %div{data: { controller: "auto-submit" }}
//       = f.select :foo, ..., data: { action: "change->auto-submit#submit" }
//
// テキスト入力のように連続して変化するものは submitDebounced を使う:
//     = f.text_field :q, data: { action: "input->auto-submit#submitDebounced" }
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  submit(event) {
    const form = event.target.closest("form")
    if (form) form.requestSubmit()
  }

  submitDebounced(event) {
    clearTimeout(this.timeout)
    const form = event.target.closest("form")
    if (!form) return

    this.timeout = setTimeout(() => form.requestSubmit(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
